
// ListarFornecedores.js

import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LastPageIcon from '@mui/icons-material/LastPage';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import '../App.css';

const ListarFornecedores = ({ handleSairListarClick, onCodigoClick }) => {
  const [fornecedoresDaPagina, setFornecedoresDaPagina] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [orderBy, setOrderBy] = useState('nomefor'); // Estado para armazenar a ordenação selecionada
  const [filtroCodFornecedor, setFiltroCodFornecedor] = useState(''); // Estado para o código de venda
  const [isFiltrando, setIsFiltrando] = useState(false); // Controle para o filtro

  useEffect(() => {
    fetchFornecedores(currentPage, orderBy);
  }, [currentPage, orderBy]);


  const fetchFornecedores = async (page, order = 'nomefor') => {
    try {
      console.log(`Solicitando fornecedores da página ${page} ordenados por ${order}...`);
      const response = await api.get(`/fornecedores/listarfornecedores/paginados?page=${page - 1}&size=10&sortBy=${order}`);

      setFornecedoresDaPagina(response.data.content);
      setTotalPages(response.data.totalPages);
      console.log(`Fornecedores da página ${page} ordenados por ${order} carregados com sucesso:`, response.data.content);
    } catch (error) {
      console.error('Erro ao carregar fornecedores:', error);
    }
  };


const buscarPorCodFornecedor = async () => {
  try {
    if (filtroCodFornecedor.trim() === '') {
      alert('Por favor, insira um código de Fornecedor válido.');
      return;
    }
    
    console.log(`Buscando Fornecedor por Código: ${filtroCodFornecedor}`);
    const response = await api.get(`/fornecedores/buscarfornecedorporcodigo?codfor=${filtroCodFornecedor}`);

    
    // Se o fornecedor foi encontrado (status 200)
    if (response.status === 200) {
      setFornecedoresDaPagina([response.data]); // Coloca o Fornecedor dentro de um array
      setIsFiltrando(true);
      setTotalPages(1); // Ajustar para evitar paginação em busca
    }
  } catch (error) {
    // Se o status for 404 (Fornecedor não encontrado)
    if (error.response && error.response.status === 404) {
      alert(`Nenhum Fornecedor encontrado para o Código: ${filtroCodFornecedor}`);
      setFornecedoresDaPagina([]); // Limpar a tabela
      setIsFiltrando(false); // Desativa o estado de filtragem
    } else {
      console.error('Erro ao buscar por código do Fornecedor:', error);
      setFornecedoresDaPagina([]); // Limpar a tabela em caso de outro Erro
      setIsFiltrando(false);
    }
  }
};
  

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };
  

  const handleOrderByNome = () => {
    setOrderBy('nomefor');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  const handleOrderByCodigo = () => {
    setOrderBy('codfor');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };


  return (
    <div>
      <Typography variant="h5" gutterBottom>Listagem de Fornecedores</Typography>

      <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
        <Typography variant="body1" style={{ marginTop: '0px', marginLeft: '20px' }}>
          Página {currentPage} de {totalPages}
        </Typography>

       {/* Botões de Navegação */}
        {!isFiltrando && (
          <Box>
            <ButtonGroup variant="contained" color="primary" style={{ height: '25px', padding: '0px 0px', marginLeft: '20px' }}>
              <Button onClick={handleFirstPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<FirstPageIcon />}></Button>
              <Button onClick={handlePreviousPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<NavigateBeforeIcon />}></Button>
              <Button onClick={handleNextPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<NavigateNextIcon />}></Button>
              <Button onClick={handleLastPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<LastPageIcon />}></Button>
            </ButtonGroup>
          </Box>
        )}

      </Box>      


<Box display="flex" justifyContent="center" alignItems="center" mt={0}>
  {/* Botões de Ordenação e Busca */}
  <Box display="flex" justifyContent="center" alignItems="center" gap={2}>

    {/* Botões de Ordenação */}
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByCodigo}
    >
      Por Código
    </Button>
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        marginLeft: '25px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByNome}
    >
      Por Fornecedor
    </Button>
         
    {/* Campo de Busca */}
    <input
      type="text"
      placeholder="Código"
      value={filtroCodFornecedor}
      onChange={(e) => setFiltroCodFornecedor(e.target.value)}
      style={{
        padding: '5px',
        width: '60px',
        marginLeft: '30px',
        height: '25px',
        fontSize: '14px'
      }}
    />
    <Button
      variant="contained"
      color="primary"
      onClick={buscarPorCodFornecedor}
      style={{
        height: '25px',
        marginLeft: '20px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
    >
      Buscar
    </Button>          
          
    {/* Botão de Fechar à Direita */}
     <button
        type="button"
        className="btn-menu"
        onClick={handleSairListarClick}
        style={{ fontSize: '12px', fontWeight: 'bold', 
          height: '25px', padding: '3px 6px', marginLeft: '30px', width: '80px', color: 'inherit' }}
      >
        Fechar
      </button>
        
        </Box>
      </Box>

      <div style={{ overflowX: 'auto', margin: '20px' }}>
        <table style={{ textAlign: 'left', borderCollapse: 'collapse', width: '100%', minWidth: '800px' }}>
          
          <thead>
          <tr>
            <th style={{ padding: '10px', width: '80px' }}>Código</th>
            <th style={{ padding: '10px', width: '200px' }}>Nome</th>
            <th style={{ padding: '10px', width: '150px' }}>Fone</th>
            <th style={{ padding: '10px', width: '150px' }}>Celular</th>
            <th style={{ padding: '10px', width: '250px' }}>Email</th>
            <th style={{ padding: '10px', width: '200px' }}>CNPJ</th>
          </tr>
        </thead>
        <tbody>
          {fornecedoresDaPagina.map((fornecedor) => (
            <tr key={fornecedor.id}>
              <td style={{ padding: '10px', cursor: 'pointer', color: 'blue', textAlign: 'center' }}
                onClick={() => onCodigoClick(fornecedor.codfor)}>{fornecedor.codfor}</td>
              <td style={{ padding: '10px' }} translate="no">{fornecedor.nomefor}</td>
              <td style={{ padding: '10px' }}>{fornecedor.fone}</td>
              <td style={{ padding: '10px' }}>{fornecedor.celular}</td>
              <td style={{ padding: '10px' }}>{fornecedor.email}</td>
              <td style={{ padding: '10px' }}>{fornecedor.cnpjfor}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

  </div>
  );
};

export default ListarFornecedores;
